import React, { createContext, useContext, useState } from "react";

const StudentContext = createContext(); // Create Student Context

export function StudentProvider({ children }) {
  const [studentData, setStudentData] = useState(null); // Store student data

  return (
    <StudentContext.Provider value={{ studentData, setStudentData }}>
      {children} {/* Wrap only student-related routes */}
    </StudentContext.Provider>
  );
}

export function useStudent() {
  return useContext(StudentContext); // Hook to access student data
}
